import { AGENCIAS_DIRECTAS } from "../constants/permisos";
import { resolverFechaFactura } from "./comisionEdificiosUtil";

export const calcularImporteNetoIntermediario = (factura, clientes, intermediarios, pais) => {
  if (!factura?.importe) return 0;
  const importeBase = parseFloat(factura.importe) || 0;
  if (importeBase <= 0) return 0;
  // Override de intermediario por venta (acuerdos de volumen, ej: OMNET): si está poblado,
  // la comisión se resuelve desde ese intermediario en vez de cliente.agencia.
  const overrideId = parseInt(factura.intermediario_override_id, 10);
  let intermediarioId;
  if (factura.intermediario_override_id != null && !isNaN(overrideId)) {
    intermediarioId = overrideId;
  } else {
    const cliente = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
    if (!cliente || !cliente.agencia) return importeBase;
    intermediarioId = parseInt(cliente.agencia, 10);
    if (isNaN(intermediarioId)) return importeBase;
  }
  const intermediario = intermediarios.find((i) => i.id === intermediarioId && i.pais === pais);
  if (!intermediario) return importeBase;
  const fechaFactura = new Date(resolverFechaFactura(factura));
  let porcentajeComision = intermediario.comision || 0;
  // Ventana comision_2 por FECHA ABSOLUTA (TZ-agnóstico), unificada con calculateAgencyCommission.
  // Antes comparaba por año (getFullYear) → bug TZ: `new Date('YYYY-01-01').getFullYear()` devuelve
  // el año anterior en TZ Chile (instante UTC → 31-dic local) → la ventana arrancaba un año antes.
  if (intermediario.comision_2 !== null && intermediario.comision_2_fechainicio && intermediario.comision_2_fechafin) {
    const inicio = new Date(intermediario.comision_2_fechainicio);
    const fin = new Date(intermediario.comision_2_fechafin);
    if (fechaFactura >= inicio && fechaFactura <= fin) {
      porcentajeComision = intermediario.comision_2 || 0;
    }
  }
  // Ventas directas: agencias 16 (Perú) y 32 (Chile) = comisión 0
  if (AGENCIAS_DIRECTAS.includes(intermediarioId)) {
    porcentajeComision = 0;
  }
  let comision = (importeBase * porcentajeComision) / 100;
  // Ventas directas: comisión 0
  if (AGENCIAS_DIRECTAS.includes(intermediarioId)) {
    comision = 0;
  }
  return importeBase - comision;
};

export const calcularPorcentajeComisionIntermediario = (factura, clientes, intermediarios, pais) => {
  if (!factura?.importe) return 0;
  // Override de intermediario por venta (acuerdos de volumen, ej: OMNET): si está poblado,
  // el porcentaje se resuelve desde ese intermediario en vez de cliente.agencia.
  const overrideId = parseInt(factura.intermediario_override_id, 10);
  let intermediarioId;
  if (factura.intermediario_override_id != null && !isNaN(overrideId)) {
    intermediarioId = overrideId;
  } else {
    const cliente = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
    if (!cliente || !cliente.agencia) return 0;
    intermediarioId = parseInt(cliente.agencia, 10);
    if (isNaN(intermediarioId)) return 0;
  }
  const intermediario = intermediarios.find((i) => i.id === intermediarioId && i.pais === pais);
  if (!intermediario) return 0;
  const fechaFactura = new Date(resolverFechaFactura(factura));
  let porcentaje = intermediario.comision || 0;
  // Ventana comision_2 por FECHA ABSOLUTA (TZ-agnóstico), unificada con calculateAgencyCommission.
  // Mismo fix que calcularImporteNetoIntermediario: antes comparaba por año (getFullYear, bug TZ).
  if (intermediario.comision_2 !== null && intermediario.comision_2_fechainicio && intermediario.comision_2_fechafin) {
    const inicio = new Date(intermediario.comision_2_fechainicio);
    const fin = new Date(intermediario.comision_2_fechafin);
    if (fechaFactura >= inicio && fechaFactura <= fin) {
      porcentaje = intermediario.comision_2 || 0;
    }
  }
  // Ventas directas: agencias 16 (Perú) y 32 (Chile) = 0%
  if (AGENCIAS_DIRECTAS.includes(intermediarioId)) {
    porcentaje = 0;
  }
  return porcentaje;
};

export const obtenerNombreIntermediario = (factura, clientes, intermediarios, pais) => {
  // Override de intermediario por venta (acuerdos de volumen, ej: OMNET): si está poblado,
  // el nombre se resuelve desde ese intermediario en vez de cliente.agencia.
  const overrideId = parseInt(factura.intermediario_override_id, 10);
  let intermediarioId;
  if (factura.intermediario_override_id != null && !isNaN(overrideId)) {
    intermediarioId = overrideId;
  } else {
    const cliente = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
    if (!cliente?.agencia) return "DIRECTO";
    intermediarioId = parseInt(cliente.agencia, 10);
    if (isNaN(intermediarioId)) return "DIRECTO";
  }
  const intermediario = intermediarios.find((i) => i.id === intermediarioId && i.pais === pais);
  return intermediario?.nombre || "DIRECTO";
};
